<template>
  <div id="mission-onelakh">
    <v-overlay :value="LoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Premium Header Card -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-gradient">
        <div class="header-backdrop-effect"></div>
        <div class="header-content pa-8">
          <v-row align="center" justify="space-between">
            <!-- Left Side: Title and Icon -->
            <v-col cols="12" md="8" class="d-flex align-center">
              <div class="header-icon-box">
                <v-icon size="40" color="white">mdi-trophy-outline</v-icon>
              </div>
              <div class="ml-4">
                <h1 class="header-title">{{ PageTitle }}</h1>
                <p class="header-subtitle">
                  {{ rows.ZoneName }} - {{ rows.LomName }}
                </p>
              </div>
            </v-col>

            <!-- Right Side: Action Buttons -->
            <v-col cols="12" md="4" class="text-right">
              <v-spacer />
              <v-btn
                medium
                @click.prevent="refreshPageData"
                color="#a4c639"
                elevation="30"
                rounded
                class="font-size-h6 mr-3 my-3 white--text action-btn"
              >
                <v-icon left>mdi-refresh</v-icon>
                Refresh
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
    <v-row wrap align="center" justify="center">
      <v-col cols="12" lg="4" md="6" sm="6" v-if="rows.Phase1Flag">
        <div id="card-body" class="premium-card-wrapper">
          <v-card id="card" class="phase-card phase-1" color="#0097d7">
            <v-card-text class="text-center">
              <!-- Achievement Badge Inside Card -->
              <div v-if="rows.Phase1IconPath != ''" class="badge-inside">
                <img
                  :src="rows.Phase1IconPath"
                  alt="Achievement Badge"
                  class="badge-image-inside"
                  v-if="rows.Phase1IconPath"
                />
              </div>
              <div class="d-flex align-center justify-center">
                <div class="phase-icon mr-3">
                  <v-icon size="48px" color="white">mdi-account-group</v-icon>
                </div>

                <h2 class="white--text d-flex align-center mb-0">
                  Step
                  <v-icon size="35px" color="white" class="ml-2">
                    mdi-numeric-1-circle
                  </v-icon>
                </h2>
              </div>
              <hr />
              <br />
              <span class="text-h5 white--text phase-title">
                The Visionary Four</span
              ><br /><br />
              <span class="text-h5 white--text"> Status:</span>&nbsp;&nbsp;
              &nbsp;
              <v-chip
                :color="getActiveStatusColor(rows.Phase1StatusTxt)"
                draggable
                dark
                >{{ rows.Phase1StatusTxt }}</v-chip
              ><v-tooltip bottom v-if="rows.Phase1CertificatePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="rows.Phase1CertificatePath"
                    target="_blank"
                    class="mx-2"
                    icon
                    dark
                    small
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span> </v-tooltip
              ><br /><br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase1DeadlineDateTxt"
              >
                DeadLine Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase1DeadlineDateTxt"
                class="text-h5 white--text"
                >{{ rows.Phase1DeadlineDateTxt }}</span
              ><br /><br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase1CompletedDateTxt && false"
              >
                Completed Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase1CompletedDateTxt && false"
                class="text-h5 white--text"
                >{{ rows.Phase1CompletedDateTxt }}</span
              >
              <br />
              <router-link to="/mission-one-lakh/committee/add-member">
                <v-btn
                  id="add-member"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Enter
                </v-btn> </router-link
              >&nbsp;&nbsp;&nbsp;
              <router-link to="/mission-one-lakh/committee/add-member">
                <v-btn
                  style="margin-top: 18px"
                  v-if="!rows.Phase1Flag"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Start
                </v-btn>
              </router-link>
              <br />
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="6">
        <div id="card-body" class="premium-card-wrapper">
          <v-card id="card" class="phase-card phase-2" color="#ffc107">
            <v-card-text class="text-center">
              <!-- Achievement Badge Inside Card -->
              <div v-if="rows.Phase2IconPath != ''" class="badge-inside">
                <img
                  :src="rows.Phase2IconPath"
                  alt="Achievement Badge"
                  class="badge-image-inside"
                  v-if="rows.Phase2IconPath"
                />
              </div>
              <div class="d-flex align-center justify-center">
                <div class="phase-icon mr-3">
                  <v-icon size="48px" color="white">mdi-target</v-icon>
                </div>

                <h2 class="white--text d-flex align-center mb-0">
                  Step
                  <v-icon size="35px" color="white" class="ml-2">
                    mdi-numeric-2-circle
                  </v-icon>
                </h2>
              </div>
              <hr />
              <br />
              <span class="text-h5 phase-title" style="color: #333">
                The Power Prospect List</span
              >
              <br /><br />
              <span class="text-h5 white--text"> Status:</span>&nbsp;&nbsp;
              &nbsp;
              <v-chip
                :color="getActiveStatusColor(rows.Phase2StatusTxt)"
                draggable
                dark
                >{{ rows.Phase2StatusTxt }}</v-chip
              ><v-tooltip bottom v-if="rows.Phase2CertificatePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="rows.Phase2CertificatePath"
                    target="_blank"
                    class="mx-2"
                    icon
                    dark
                    small
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span> </v-tooltip
              ><br />
              <br />
              <span class="text-h5 white--text"> DeadLine Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span class="text-h5 white--text">{{
                rows.Phase2DeadlineDateTxt
              }}</span
              ><br /><br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase2CompletedDateTxt && false"
              >
                Completed Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase2CompletedDateTxt && false"
                class="text-h5 white--text"
                >{{ rows.Phase2CompletedDateTxt }}</span
              >
              <br />
              <router-link to="/mission-one-lakh/member-list">
                <v-btn
                  id="add-member"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Enter
                </v-btn> </router-link
              >&nbsp;&nbsp;&nbsp;
              <router-link
                to="/mission-one-lakh/member-list"
                v-if="!rows.Phase2Flag"
              >
                <v-btn
                  style="margin-top: 18px"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Start
                </v-btn>
              </router-link>
              <br />
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="6" v-if="rows.Phase3Flag">
        <div id="card-body" class="premium-card-wrapper">
          <v-card id="card" class="phase-card phase-3" color="#ff9800">
            <v-card-text>
              <!-- Achievement Badge Inside Card -->
              <div v-if="rows.Phase3IconPath != ''" class="badge-inside">
                <img
                  :src="rows.Phase3IconPath"
                  alt="Achievement Badge"
                  class="badge-image-inside"
                  v-if="rows.Phase3IconPath"
                />
              </div>
              <div class="d-flex align-center justify-center">
                <div class="phase-icon mr-3">
                  <v-icon size="48px" color="white">mdi-school</v-icon>
                </div>

                <h2 class="white--text d-flex align-center mb-0">
                  Step
                  <v-icon size="35px" color="white" class="ml-2">
                    mdi-numeric-3-circle
                  </v-icon>
                </h2>
              </div>
              <hr />
              <br />
              <span class="text-h5 white--text">
                Potential Members visited / invited</span
              >
              <br /><br />
              <span class="text-h5 white--text"> Status:</span>&nbsp;&nbsp;
              &nbsp;
              <v-chip
                :color="getActiveStatusColor(rows.Phase3StatusTxt)"
                draggable
                dark
                >{{ rows.Phase3StatusTxt }}</v-chip
              ><v-tooltip bottom v-if="rows.Phase3CertificatePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="rows.Phase3CertificatePath"
                    target="_blank"
                    class="mx-2"
                    icon
                    dark
                    small
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span> </v-tooltip
              ><br />
              <br />
              <span class="text-h5 white--text"> DeadLine Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span class="text-h5 white--text">{{
                rows.Phase3DeadlineDateTxt
              }}</span
              ><br /><br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase3CompletedDateTxt"
              >
                Completed Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase3CompletedDateTxt"
                class="text-h5 white--text"
                >{{ rows.Phase3CompletedDateTxt }}</span
              >
              <br /><br />
              <router-link to="/mission-one-lakh/invited/member-list">
                <v-btn
                  v-if="rows.Phase3ViewFlag"
                  id="add-member1"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  View
                </v-btn> </router-link
              >&nbsp;&nbsp;&nbsp;
              <router-link to="/mission-one-lakh/invited/member-list">
                <v-btn
                  v-if="!rows.Phase3Flag"
                  style="margin-top: 5px"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Start
                </v-btn>
              </router-link>
              <br />
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row wrap align="center">
      <v-col cols="12" lg="4" md="6" sm="6" v-if="CardFlag4">
        <div id="card-body" class="premium-card-wrapper">
          <v-card id="card" class="phase-card phase-4" color="#f44336">
            <v-card-text>
              <!-- Achievement Badge Inside Card -->
              <div v-if="rows.Phase4IconPath != ''" class="badge-inside">
                <img
                  :src="rows.Phase4IconPath"
                  alt="Achievement Badge"
                  class="badge-image-inside"
                  v-if="rows.Phase4IconPath"
                />
              </div>
              <div class="d-flex align-center justify-center">
                <div class="phase-icon mr-3">
                  <v-icon size="48px" color="white">mdi-star-outline</v-icon>
                </div>

                <h2 class="white--text d-flex align-center mb-0">
                  Step
                  <v-icon size="35px" color="white" class="ml-2">
                    mdi-numeric-4-circle
                  </v-icon>
                </h2>
              </div>
              <hr />
              <br />
              <span class="text-h5 white--text">
                Potential Members re-visited / re-invited</span
              >
              <br /><br />
              <span class="text-h5 white--text"> Status:</span>&nbsp;&nbsp;
              &nbsp;
              <v-chip
                :color="getActiveStatusColor(rows.Phase4StatusTxt)"
                draggable
                dark
                >{{ rows.Phase4StatusTxt }}</v-chip
              >
              <v-tooltip bottom v-if="rows.Phase4CertificatePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="rows.Phase4CertificatePath"
                    target="_blank"
                    class="mx-2"
                    icon
                    dark
                    small
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span> </v-tooltip
              ><br />
              <br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase4DeadlineDateTxt"
              >
                DeadLine Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase4DeadlineDateTxt"
                class="text-h5 white--text"
                >{{ rows.Phase4DeadlineDateTxt }}</span
              ><br /><br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase4CompletedDateTxt"
              >
                Completed Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase4CompletedDateTxt"
                class="text-h5 white--text"
                >{{ rows.Phase4CompletedDateTxt }}</span
              >
              <br /><br />
              <router-link to="/mission-one-lakh/re-invited/member-list">
                <v-btn
                  v-if="rows.Phase4ViewFlag"
                  id="add-member1"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  View
                </v-btn>
              </router-link>
              &nbsp;&nbsp;&nbsp;
              <router-link to="/mission-one-lakh/re-invited/member-list">
                <v-btn
                  v-if="!rows.Phase4Flag"
                  style="margin-top: 5px"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Start
                </v-btn>
              </router-link>
              <br />
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-row wrap align="center" justify="center">
      <v-col cols="12" lg="4" md="6" sm="6">
        <div id="card-body" class="premium-card-wrapper">
          <v-card id="card" class="phase-card phase-5" color="#ff9800">
            <v-card-text class="text-center">
              <!-- Achievement Badge Inside Card -->
              <div v-if="rows.Phase5IconPath != ''" class="badge-inside">
                <img
                  :src="rows.Phase5IconPath"
                  alt="Achievement Badge"
                  class="badge-image-inside"
                  v-if="rows.Phase5IconPath"
                />
              </div>

              <div class="d-flex align-center justify-center">
                <div class="phase-icon mr-3">
                  <v-icon size="48px" color="white"
                    >mdi-lightbulb-outline</v-icon
                  >
                </div>

                <h2 class="white--text d-flex align-center mb-0">
                  Step
                  <v-icon size="35px" color="white" class="ml-2">
                    mdi-numeric-3-circle
                  </v-icon>
                </h2>
              </div>
              <hr />
              <br />
              <span class="text-h5 white--text phase-title">
                The Grand Orientation</span
              >
              <br /><br />
              <span class="text-h5 white--text"> Status:</span>&nbsp;&nbsp;
              &nbsp;
              <v-chip
                :color="getActiveStatusColor(rows.Phase5StatusTxt)"
                draggable
                dark
                >{{ rows.Phase5StatusTxt }}</v-chip
              >
              <v-tooltip bottom v-if="rows.Phase5CertificatePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="rows.Phase5CertificatePath"
                    target="_blank"
                    class="mx-2"
                    icon
                    dark
                    small
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span> </v-tooltip
              ><br />
              <br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase5DeadlineDateTxt"
              >
                DeadLine Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase5DeadlineDateTxt"
                class="text-h5 white--text"
                >{{ rows.Phase5DeadlineDateTxt }}</span
              ><br /><br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase5CompletedDateTxt && false"
              >
                Completed Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase5CompletedDateTxt && false"
                class="text-h5 white--text"
                >{{ rows.Phase5CompletedDateTxt }}</span
              >
              <br />
              <router-link to="/mission-one-lakh/attended/member-list">
                <v-btn
                  v-if="rows.Phase5ViewFlag"
                  style="margin-left: 1px"
                  id="add-member1"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  View
                </v-btn> </router-link
              >&nbsp;&nbsp;&nbsp;
              <router-link to="/mission-one-lakh/attended/member-list">
                <v-btn
                  v-if="!rows.Phase5Flag"
                  id="add-member1"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Start
                </v-btn>
              </router-link>
              <br />
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="6">
        <div id="card-body" class="premium-card-wrapper">
          <v-card id="card" class="phase-card phase-6" color="#d32f2f">
            <v-card-text class="text-center">
              <!-- Achievement Badge Inside Card -->
              <div
                v-if="rows.Phase6StatusTxt === 'Completed'"
                class="badge-inside"
              >
                <img
                  :src="rows.Phase6IconPath"
                  alt="Achievement Badge"
                  class="badge-image-inside"
                  v-if="rows.Phase6IconPath"
                />
              </div>
              <div class="d-flex align-center justify-center">
                <div class="phase-icon mr-3">
                  <v-icon size="48px" color="white">mdi-star-outline</v-icon>
                </div>

                <h2 class="white--text d-flex align-center mb-0">
                  Step
                  <v-icon size="35px" color="white" class="ml-2">
                    mdi-numeric-4-circle
                  </v-icon>
                </h2>
              </div>
              <hr />
              <br />
              <span class="text-h5 white--text phase-title">
                The Conversion Challenge</span
              ><br /><br />
              <span class="text-h5 white--text"> Status:</span>&nbsp;&nbsp;
              &nbsp;
              <v-chip
                :color="getActiveStatusColor(rows.Phase6StatusTxt)"
                draggable
                dark
                >{{ rows.Phase6StatusTxt }}</v-chip
              >
              <v-tooltip bottom v-if="rows.Phase6CertificatePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="rows.Phase6CertificatePath"
                    target="_blank"
                    class="mx-2"
                    icon
                    dark
                    small
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span> </v-tooltip
              ><br />
              <br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase6DeadlineDateTxt"
              >
                DeadLine Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase6DeadlineDateTxt"
                class="text-h5 white--text"
                >{{ rows.Phase6DeadlineDateTxt }}</span
              ><br />
              <span
                class="text-h5 white--text"
                v-if="rows.Phase6CompletedDateTxt && false"
              >
                Completed Date:</span
              >&nbsp;&nbsp; &nbsp;
              <span
                v-if="rows.Phase6CompletedDateTxt && false"
                class="text-h5 white--text"
                >{{ rows.Phase6CompletedDateTxt }}</span
              >
              <br /><br />
              <router-link to="/mission-one-lakh/join-jci-member-list">
                <v-btn
                  v-if="rows.Phase6ViewFlag"
                  style="margin-left: 1px"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  View
                </v-btn> </router-link
              >&nbsp;&nbsp;&nbsp;
              <router-link to="/mission-one-lakh/join-jci-member-list">
                <v-btn
                  id="add-member1"
                  rounded
                  color="#000"
                  class="font-size-h6 white--text"
                >
                  Start
                </v-btn>
              </router-link>
              <br />
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <br />
  </div>
</template>
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  data() {
    return {
      CardFlag1: true,
      CardFlag2: true,
      CardFlag3: true,
      CardFlag4: false,
      CardFlag5: true,
      CardFlag6: true,

      addRecordPrompt: false,
      LoadingFlag: false,
      PageInfo: {},
      rows: {
        Phase1Flag: true,
      },
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        this.pageData();
      }
    },
    rows: function () {
      console.log("watch rows");
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "mission_one_lakh",
        Action: "dashboard",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.getTableRecords();
    },
    pageData() {
      console.log("pageData called");
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var YearCode = this.JciYearCode;
      console.log("YearCode=" + YearCode);

      // this.rows = [];

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/mol-dashboard";
      var upload = {
        UserInterface: 1,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      //this.rows = [];
      this.SearchFlag = true;
      this.LoadingFlag = true;
      this.OverlayLoadingFlag = true;

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.SearchFlag = false;
          thisIns.LoadingFlag = false;
          thisIns.StartupLoadingFlag = false;
          thisIns.OverlayLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log(
            "output=" + output + ", flag=" + flag + ", records=" + records
          );

          if (flag == 1) {
            thisIns.rows = records;
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.toast("error", error);
          thisIns.SearchFlag = false;
          thisIns.LoadingFlag = false;
        });
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
// Color Palette
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$yellow: #ffc107;
$orange: #ff9800;
$red: #f44336;
$dark-red: #d32f2f;
$text-white: #ffffff;

#mission-onelakh {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;

  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  .notes-title {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }

  .notes-content {
    font-size: 20px;
    font-weight: bold;
    line-height: 2em;
  }

  // ============================================
  // KEYFRAME ANIMATIONS
  // ============================================
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slideInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-12px);
    }
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes glow {
    0%,
    100% {
      box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
    }
    50% {
      box-shadow: 0 0 25px rgba(255, 255, 255, 0.6);
    }
  }

  @keyframes pulse-scale {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.02);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes titleGlow {
    0%,
    100% {
      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4), 0 0 25px rgba(0, 0, 0, 0.2);
    }
    50% {
      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4), 0 0 35px rgba(0, 0, 0, 0.35);
    }
  }

  @keyframes badgePulseLight {
    0%,
    100% {
      filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.3))
        drop-shadow(0 0 15px rgba(255, 255, 255, 0.1));
    }
    50% {
      filter: drop-shadow(0 8px 25px rgba(0, 0, 0, 0.4))
        drop-shadow(0 0 20px rgba(255, 255, 255, 0.15));
    }
  }

  @keyframes iconWhiteBlink {
    0%,
    100% {
      color: white;
      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4),
        0 0 20px rgba(255, 255, 255, 0.3), 0 0 40px rgba(255, 255, 255, 0.2);
      filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.4));
    }
    50% {
      color: #ffffff;
      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5),
        0 0 35px rgba(255, 255, 255, 0.6), 0 0 60px rgba(255, 255, 255, 0.4);
      filter: drop-shadow(0 0 25px rgba(255, 255, 255, 0.7))
        drop-shadow(0 0 50px rgba(255, 255, 255, 0.3));
    }
  }

  // ============================================
  // HEADER CARD STYLES
  // ============================================
  .header-card {
    background: linear-gradient(
      135deg,
      $navy 0%,
      $aqua 50%,
      $navy 100%
    ) !important;
    border-radius: 20px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5),
      0 0 40px rgba(0, 151, 215, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        45deg,
        transparent 30%,
        rgba(255, 255, 255, 0.1) 50%,
        transparent 70%
      );
      animation: shimmer 3s infinite;
    }

    .header-gradient {
      position: relative;
      z-index: 1;
    }

    .header-backdrop-effect {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 70%
      );
      animation: rotate 25s linear infinite;
    }

    .header-content {
      position: relative;
      z-index: 2;
    }
  }

  .header-icon-box {
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.25) 0%,
      rgba(255, 255, 255, 0.15) 100%
    );
    backdrop-filter: blur(15px);
    border-radius: 18px;
    padding: 14px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
    animation: float 4s ease-in-out infinite;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }

  .header-title {
    font-size: 36px;
    font-weight: 900;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 151, 215, 0.3);
    animation: slideInLeft 0.8s ease-out;
    letter-spacing: 0.8px;
    color: $text-white;
    margin: 0;
  }

  .header-subtitle {
    font-size: 17px;
    opacity: 0.98;
    animation: slideInLeft 1s ease-out 0.1s backwards;
    letter-spacing: 0.4px;
    color: $text-white;
    font-weight: 500;
    margin: 6px 0 0 0;
  }

  .action-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    color: white !important;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
      background: rgba(255, 255, 255, 0.25) !important;
    }
  }

  // ============================================
  // PREMIUM CARD WRAPPER
  // ============================================
  .premium-card-wrapper {
    position: relative;
    height: 580px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    animation: slideInUp 0.9s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s backwards;
    transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    overflow: hidden;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.05) 100%
    );

    &:hover {
      transform: translateY(-12px);
      box-shadow: 0 30px 80px rgba(0, 0, 0, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
      border-radius: 24px;
    }
  }

  // ============================================
  // PHASE CARD STYLING
  // ============================================
  .phase-card {
    position: absolute;
    top: 12px;
    left: 12px;
    right: 12px;
    bottom: 12px;
    border-radius: 16px !important;
    overflow-y: auto;
    overflow-x: hidden;
    transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    backdrop-filter: blur(8px);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        45deg,
        transparent 30%,
        rgba(255, 255, 255, 0.08) 50%,
        transparent 70%
      );
      animation: shimmer 3s infinite;
      z-index: 1;
    }

    .v-card__text {
      position: relative;
      z-index: 2;
      padding: 24px 20px 40px 20px;
      animation: slideInUp 1s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s backwards;
    }
  }

  // Phase-specific styling
  .phase-1 {
    background: linear-gradient(
      135deg,
      #0097d7 0%,
      #00b4e6 50%,
      #0086c3 100%
    ) !important;
    box-shadow: 0 20px 50px rgba(0, 151, 215, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(
        circle at 20% 50%,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 50%
      );
      border-radius: 12px;
      z-index: 0;
    }
  }

  .phase-2 {
    background: linear-gradient(
      135deg,
      #ffc107 0%,
      #ffeb3b 50%,
      #ffb300 100%
    ) !important;
    box-shadow: 0 20px 50px rgba(255, 193, 7, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.3) !important;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(
        circle at 20% 50%,
        rgba(255, 255, 255, 0.2) 0%,
        transparent 50%
      );
      border-radius: 12px;
      z-index: 0;
    }

    .white--text {
      color: #333 !important;
    }

    .v-btn {
      color: white !important;
    }

    hr {
      border-color: rgba(0, 0, 0, 0.1) !important;
    }
  }

  .phase-3 {
    background: linear-gradient(
      135deg,
      #ff9800 0%,
      #ffb74d 50%,
      #ff8500 100%
    ) !important;
    box-shadow: 0 20px 50px rgba(255, 152, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(
        circle at 20% 50%,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 50%
      );
      border-radius: 12px;
      z-index: 0;
    }
  }

  .phase-4 {
    background: linear-gradient(
      135deg,
      #f44336 0%,
      #ef5350 50%,
      #e53935 100%
    ) !important;
    box-shadow: 0 20px 50px rgba(244, 67, 54, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(
        circle at 20% 50%,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 50%
      );
      border-radius: 12px;
      z-index: 0;
    }
  }

  .phase-5 {
    background: linear-gradient(
      135deg,
      #ff9800 0%,
      #ffb74d 50%,
      #ff8500 100%
    ) !important;
    box-shadow: 0 20px 50px rgba(255, 152, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(
        circle at 20% 50%,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 50%
      );
      border-radius: 12px;
      z-index: 0;
    }
  }

  .phase-6 {
    background: linear-gradient(
      135deg,
      #d32f2f 0%,
      #e53935 50%,
      #c62828 100%
    ) !important;
    box-shadow: 0 20px 50px rgba(211, 47, 47, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.15) !important;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(
        circle at 20% 50%,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 50%
      );
      border-radius: 12px;
      z-index: 0;
    }
  }

  #card-body {
    position: relative;
    height: 560px;
  }

  #add-member {
    margin-top: 20px !important;
    margin-bottom: 16px !important;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    font-weight: 800 !important;
    font-family: "Segoe UI", "Trebuchet MS", sans-serif !important;
    font-size: 0.95rem !important;
    text-transform: uppercase !important;
    letter-spacing: 0.8px !important;
    background: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.4) 100%
    ) !important;
    border: 2px solid rgba(255, 255, 255, 0.4) !important;
    backdrop-filter: blur(12px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.25) !important;
    padding: 12px 28px !important;
    border-radius: 10px !important;
    position: relative;
    z-index: 10;
    display: inline-block !important;

    &:hover {
      transform: translateY(-6px) scale(1.08);
      box-shadow: 0 14px 35px rgba(0, 0, 0, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.35) !important;
      background: linear-gradient(
        135deg,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(0, 0, 0, 0.5) 100%
      ) !important;
    }

    &:active {
      transform: translateY(-3px) scale(1.05);
    }
  }

  #add-member1 {
    margin-top: 20px !important;
    margin-bottom: 16px !important;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    font-weight: 800 !important;
    font-family: "Segoe UI", "Trebuchet MS", sans-serif !important;
    font-size: 0.95rem !important;
    text-transform: uppercase !important;
    letter-spacing: 0.8px !important;
    background: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.4) 100%
    ) !important;
    border: 2px solid rgba(255, 255, 255, 0.4) !important;
    backdrop-filter: blur(12px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.25) !important;
    padding: 12px 28px !important;
    border-radius: 10px !important;
    position: relative;
    z-index: 10;
    display: inline-block !important;

    &:hover {
      transform: translateY(-6px) scale(1.08);
      box-shadow: 0 14px 35px rgba(0, 0, 0, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.35) !important;
      background: linear-gradient(
        135deg,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(0, 0, 0, 0.5) 100%
      ) !important;
    }

    &:active {
      transform: translateY(-3px) scale(1.05);
    }
  }

  .phase-icon {
    font-size: 72px;
    color: white;
    margin-bottom: 16px;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.25s backwards,
      iconWhiteBlink 2.5s ease-in-out 1.2s infinite;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4),
      0 0 25px rgba(255, 255, 255, 0.3);
    filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.3));
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    display: inline-block;
    padding: 16px 20px;
    border-radius: 20px;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.15) 0%,
      rgba(255, 255, 255, 0.05) 100%
    );
    box-shadow: 0 10px 40px rgba(255, 255, 255, 0.25),
      inset 0 1px 0 rgba(255, 255, 255, 0.3), 0 0 30px rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(10px);
    position: relative;
    z-index: 5;

    &:hover {
      transform: translateY(-8px) scale(1.15);
      box-shadow: 0 16px 50px rgba(255, 255, 255, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.4),
        0 0 45px rgba(255, 255, 255, 0.25);
      filter: drop-shadow(0 0 20px rgba(255, 255, 255, 0.5))
        drop-shadow(0 0 40px rgba(255, 255, 255, 0.2));
    }
  }

  .phase-title {
    font-family: "Segoe UI", "Trebuchet MS", sans-serif;
    font-weight: 900 !important;
    font-size: 1.42rem !important;
    text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5), 0 0 30px rgba(0, 0, 0, 0.25);
    animation: slideInLeft 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s backwards;
    letter-spacing: 1.2px;
    display: inline-block;
    padding: 14px 24px;
    border-radius: 12px;
    background: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.25) 0%,
      rgba(0, 0, 0, 0.15) 100%
    );
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.25);
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    position: relative;
    line-height: 1.2;

    &:hover {
      transform: translateY(-5px) scale(1.1);
      box-shadow: 0 14px 35px rgba(0, 0, 0, 0.4),
        inset 0 1px 0 rgba(255, 255, 255, 0.3);
      background: linear-gradient(
        135deg,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(0, 0, 0, 0.2) 100%
      );
    }
  }

  // ============================================
  // ENHANCED ELEMENTS
  // ============================================
  .v-chip {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    font-weight: 700;
    letter-spacing: 0.3px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;

    &:hover {
      transform: translateY(-2px) scale(1.08);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3) !important;
    }
  }

  h2 {
    animation: titleGlow 3s ease-in-out infinite;
    font-weight: 900;
    letter-spacing: 1.5px;
    margin-bottom: 12px;
    font-family: "Segoe UI", "Trebuchet MS", sans-serif;
    font-size: 1.1rem !important;
  }

  hr {
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.4) 50%,
      transparent 100%
    );
    border: none;
    height: 2px;
    margin: 16px 0;
    animation: slideInLeft 0.8s ease-out 0.4s backwards;
  }

  .v-card__text {
    word-wrap: break-word;
  }

  .text-h5 {
    font-family: "Segoe UI", "Trebuchet MS", sans-serif !important;
    font-weight: 600 !important;
    letter-spacing: 0.3px !important;
  }

  // ============================================
  // BADGE INSIDE CARD STYLES
  // ============================================
  .badge-inside {
    position: relative;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s backwards;

    .badge-image-inside {
      width: 110px;
      height: 110px;
      display: block;
      filter: drop-shadow(0 12px 30px rgba(0, 0, 0, 0.4))
        drop-shadow(0 0 20px rgba(255, 255, 255, 0.2));
      transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.15) 0%,
        rgba(255, 255, 255, 0.05) 100%
      );
      border-radius: 50%;
      padding: 12px;
      box-shadow: inset 0 2px 12px rgba(255, 255, 255, 0.3),
        0 12px 30px rgba(0, 0, 0, 0.35), inset 0 -2px 8px rgba(0, 0, 0, 0.1);
      border: 3px solid rgba(255, 255, 255, 0.3);
      animation: badgePulseLight 3s ease-in-out infinite;
      object-fit: contain;

      &:hover {
        transform: scale(1.2) translateY(-8px);
        filter: drop-shadow(0 16px 40px rgba(0, 0, 0, 0.5))
          drop-shadow(0 0 25px rgba(255, 255, 255, 0.25));
        box-shadow: inset 0 2px 12px rgba(255, 255, 255, 0.4),
          0 16px 40px rgba(0, 0, 0, 0.45), inset 0 -2px 8px rgba(0, 0, 0, 0.15);
        animation: none;
      }
    }
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 960px) {
    padding: 20px 12px;

    .header-title {
      font-size: 28px;
    }

    .header-subtitle {
      font-size: 14px;
    }

    .header-icon-box {
      padding: 10px;
    }

    #card-body {
      height: 560px;
    }

    #card {
      top: 10px;
      left: 10px;
      right: 10px;
      bottom: 10px;
    }

    .premium-card-wrapper {
      height: 580px;
    }

    .phase-icon {
      font-size: 60px;
      padding: 14px 18px;
      margin-bottom: 14px;
    }

    .badge-image-inside {
      width: 100px !important;
      height: 100px !important;
    }
  }

  @media (max-width: 600px) {
    padding: 16px 10px;

    .header-card {
      margin-bottom: 16px;

      .header-content {
        padding: 16px !important;
      }
    }

    .header-title {
      font-size: 22px;
    }

    .header-subtitle {
      font-size: 13px;
    }

    #card-body {
      height: 540px;
    }

    #card {
      top: 8px;
      left: 8px;
      right: 8px;
      bottom: 8px;
    }

    #add-member,
    #add-member1 {
      margin-top: 16px !important;
      font-size: 12px !important;
      padding: 10px 20px !important;
    }

    .premium-card-wrapper {
      height: 560px;
    }

    .phase-title {
      font-size: 1.2rem !important;
      padding: 10px 16px !important;
    }

    .badge-image-inside {
      width: 90px !important;
      height: 90px !important;
    }

    .phase-icon {
      font-size: 52px;
      padding: 12px 16px;
      margin-bottom: 12px;
    }
  }
}
</style>